import { Component, Input } from '@angular/core';

import { formatAddressTitle } from 'src/app/utils/address-format.utils';

@Component({
  selector: 'app-immeuble-card',
  templateUrl: './immeuble-card.component.html',
  styleUrls: ['./immeuble-card.component.scss']
})
export class ImmeubleCardComponent {
  @Input() item: any;

  formatTitle(item: any): string {
    return formatAddressTitle(item.adresse_immeuble);
  }
}
